// /results — the consolidated national destination.
//
// Layout (top to bottom):
//   1. Header (site chrome)
//   2. ResultsMap — geographic at-a-glance, 13 districts, 5 bands each
//   3. NationalRollup — seats per party as districts complete
//   4. All 13 DistrictResultsCards stacked, ordered D1..D13
//   5. Footer
//
// One page, the authoritative full picture. No district picker — the
// reader scrolls. Anchor ids per district let other surfaces deep-link
// to a specific card (#district-13 etc.).

import Header from '../Header';
import Footer from '../Footer';
import ResultsMap from './ResultsMap';
import NationalRollup from './NationalRollup';
import DistrictResultsCard from './DistrictResultsCard';
import { DISTRICT_NUMBERS } from '../../data/electionday-results-types';
import './Results.css';

export default function ResultsPage() {
  return (
    <>
      <div className="site-top">
        <Header />
      </div>
      <main className="results-page">
        <header className="results-page__header">
          <p className="results-page__kicker">Election 2026 · Live count</p>
          <h1 className="results-page__title">Results</h1>
        </header>

        <ResultsMap title="National results map" />
        <NationalRollup />

        {DISTRICT_NUMBERS.map((d) => (
          <div key={d} id={`district-${d}`}>
            <DistrictResultsCard districtId={d} />
          </div>
        ))}
      </main>
      <Footer />
    </>
  );
}
